import LinkSecondaryAsAnchor from './LinkSecondaryAsAnchor';

export default LinkSecondaryAsAnchor;
